import { ActionTypes } from "../../constants/ActionTypes";
import { IAttachmentList, IUploadAttachment } from "../../interfaces";

// attachment
export const onGetAttachment = (letterCode: string | undefined) => {
    return {
        letterCode: letterCode,
        type: ActionTypes.GET_Attachment,
    };
};

export const onGetAttachmentById = (
    letterCode: string | undefined,
    attachmentId: number
) => {
    return {
        payload: {
            letterCode: letterCode,
            attachmentId: attachmentId,
        },
        type: ActionTypes.GET_Attachment_BY_ID,
    };
};

export const onGetAttachmentByIdSuccess = (action: any) => {
    return {
        payload: action.data,
        type: ActionTypes.FETCH_Attachment_BY_ID_SUCCESS,
    };
};

export const onUploadAttachment = (model: IUploadAttachment) => {
    return {
        uploadAttachmentModel: model,
        type: ActionTypes.UPLOAD_ATTACHMENT,
    };
};

export const onUploadAttachmentSuccess = (
    letterAttachmentId: number,
    fileName: string
) => {
    return {
        payload: {
            letterAttachmentId: letterAttachmentId,
            fileName: fileName,
        },
        type: ActionTypes.UPLOAD_ATTACHMENT_SUCCESS,
    };
};

export const onClearAttachmentState = () => {
    return {
        type: ActionTypes.CLEAR_ATTACHMENT,
    };
};

export const onRemoveAttachment = (
    letterCode: string,
    letterAttachmentId: number
) => {
    return {
        payload: {
            letterCode: letterCode,
            letterAttachmentId: letterAttachmentId,
        },
        type: ActionTypes.REMOVE_ATTACHMENT,
    };
};

export const onRemoveAttachmentSuccess = (
    letterAttachmentId: number,
    fileName: string
) => {
    return {
        payload: {
            letterAttachmentId: letterAttachmentId,
            fileName: fileName,
        },
        type: ActionTypes.REMOVE_ATTACHMENT_SUCCESS,
    };
};

export const fetchAttachmentSuccess = (attachment: IAttachmentList[]) => {
    return {
        type: ActionTypes.FETCH_Attachment_SUCCESS,
        payload: attachment,
    };
};
